import { FC, useContext } from 'react';

// Components
import PlayerMetric from './PlayerMetric';

// Utils
import { getLabelValue } from '@sportal365/smp-widget-utils';
import { ConfigContext } from '@velinsi/smp-widgets-ui';

// Types
import { IPlayerBio } from '../../../../types';

const PlayerBio: FC<IPlayerBio> = ({ position, profile, shirtNumber, age }) => {
  const { dataLabels } = useContext(ConfigContext);

  return (
    <div className='player-bio-container min-w-full tb:min-w-[375px]'>
      <div className='player-bio-header flex justify-center h-[28px] rounded-t-2 bg-playerBioBackgroundColor'>
        <span className='player-bio-header-title text-playerBioTextColor text-4 leading-[20px] py-1 font-semibold'>
          {getLabelValue(dataLabels?.player_bio, 'Player bio')}
        </span>
      </div>
      <div className='player-bio-metrics-container py-4 px-7 grid items-center gap-2 justify-between rounded-b-2 border-[1px] border-playerProfileBorderColor border-t-0 border-b-0 tb:border-b-[1px] grid-cols-[120px_120px] tb:grid-cols-[1fr_1fr_1fr_1fr] lg:grid-cols-[120px_120px]'>
        <PlayerMetric label={getLabelValue(dataLabels?.position, 'Position')} value={position ?? ''} />
        <PlayerMetric label={getLabelValue(dataLabels?.shirt_number, 'Shirt number')} value={shirtNumber} />
        <PlayerMetric
          label={`${getLabelValue(dataLabels?.height, 'Height')} / ${getLabelValue(dataLabels?.weight, 'Weight')}`}
          value={profile ? `${profile.height} / ${profile.weight}` : '-'}
        />
        <PlayerMetric label={getLabelValue(dataLabels?.age, 'Age')} value={age} />
      </div>
    </div>
  );
};

export default PlayerBio;
